import { inject, Injectable } from '@angular/core';
import { CustomPropertyLoader, ICustomProperties } from '@cemex-core/cmx-rollout-toggle-v1';
import { State, getAppState } from '@cemex/cmx-client-layout';
import { select, Store } from '@ngrx/store';
import { SessionService } from '@cemex-core/angular-services-v8';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const featurePropertiesFromStorage = (
  customer?: { countryCode?: string; legalEntityTypeCode?: string } | null,
  userProfile?: { userAccount?: string } | null,
) => {
  let props = {};
  if (customer && customer.countryCode && customer.legalEntityTypeCode) {
    props = {
      countryCode: customer.countryCode,
      legalEntityTypeCode: customer.legalEntityTypeCode,
      businessLineCode: '',
    };
  }

  if (userProfile && userProfile.userAccount) {
    props = {
      ...props,
      userEmail: userProfile.userAccount,
    };
  }

  return props;
};

@Injectable()
export class AppPropertyLoader extends CustomPropertyLoader {
  private sessionService: SessionService = inject(SessionService);
  constructor(private store: Store<State>) {
    super();
  }

  public getCustomProperties(): Observable<ICustomProperties> {
    return this.store.pipe(
      select(getAppState),
      map((stateData) => {
        if (stateData.auth && stateData.auth.country && stateData.legalEntity) {
          return {
            countryCode: stateData.auth.country,
            userEmail: stateData.auth.profile.userAccount,
            legalEntityTypeCode: stateData.legalEntity.legalEntityTypeCode,
            businessLineCode: '',
          };
        }
        return this.getCustomPropertiesFromStorage();
      }),
    );
  }

  private getCustomPropertiesFromStorage() {
    const customer = this.getCustomer();
    const userProfile = this.sessionService.userProfile;

    if (!customer) {
      console.error('FATAL ERROR: missing customer data in storages');
    }

    const tokenData = this.sessionService.dataSession;
    const customerData = this.mapSessionDataToCustomer(tokenData);
    return featurePropertiesFromStorage(customerData, userProfile);
  }

  getCustomer() {
    return this.sessionService.currentLegalEntityValue;
  }

  /**
   * Maps session data to a customer object with specific properties.
   *
   * @param sessionData - The session data object containing customer and country information.
   * @returns An object containing the mapped customer data, including the country code
   *          and legal entity type code.
   */
  mapSessionDataToCustomer(sessionData: any) {
    const customerData = {
      countryCode: sessionData?.country,
      legalEntityTypeCode: sessionData?.customer?.customerCode,
    };
    return customerData;
  }
}

export function appPropertyLoaderFactory(store: Store<State>): CustomPropertyLoader {
  return new AppPropertyLoader(store);
}
